// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BASE_API_URL: 'https://api.seatfrog-backend-staging.com',
  STATIONS_API_URL: 'https://api.seatfrog-backend-staging.com/stations',
  FLEX_API_URL: 'https://api.seatfrog-backend-staging.com/flex',
  CLIENT_CODE: 'seatfrogweb',
  VALIDATE_MERCHANT_URL: 'https://api.seatfrog-backend-staging.com/payments/apple-pay/validate-merchant',
  APPLE_PAY_MERCHANT_ID: 'merchant.com.adyen.seatfrog-dev',
  APPLE_PAY_DISPLAY_NAME: 'Secret Fare UAT',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
